import { Stack, Typography } from '@mui/material'
import { FieldErrors, UseFormSetValue } from 'react-hook-form'
import { DateTimePickerField } from 'utoniq-ui'

import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'
import { convertDatePickerValueToDate, dayjs } from '@/lib/dayjs'

import { CreateItemProps } from '../ItemCreateForm'
import { ToggleInputCell } from './Commons'

type ShareInputCellProps = {
  value: boolean
  endedAt?: string
  setValue: UseFormSetValue<CreateItemProps>
  errors?: FieldErrors<CreateItemProps>
}

export const ShareInputCell: Cell<ShareInputCellProps> = ({
  value,
  endedAt,
  setValue,
  errors,
}) => {
  const { t } = useTranslation('consoleItemCreate')

  return (
    <CellFrame sx={{ pb: 6 }}>
      <ToggleInputCell
        checked={value}
        onChange={(event, checked) => {
          setValue('metadata.ticket.distributionEnabled', checked as never, {
            shouldDirty: true,
            shouldValidate: true,
          })
          if (!checked) {
            setValue('metadata.ticket.distributionEndedAt', null as never, {
              shouldDirty: true,
              shouldValidate: true,
            })
          }
        }}
        content={{
          title: t('shareEnabledLabel'),
          description: (
            <Stack spacing={2}>
              <Typography variant="body2" color="text.secondary">
                {t('shareEnabledDesc')}
              </Typography>
            </Stack>
          ),
        }}
        sx={{ pb: 4 }}
      />
      {value && (
        <Stack>
          <DateTimePickerField
            onChange={date => {
              setValue(
                'metadata.ticket.distributionEndedAt',
                (convertDatePickerValueToDate(date) || null) as never,
                {
                  shouldValidate: true,
                  shouldDirty: true,
                }
              )
            }}
            value={endedAt ? dayjs(endedAt) : null}
            title={t('shareDistributionEndedAtTitle')}
            description={t('shareDistributionEndedAtDesc')}
            placeholder={t('shareDistributionEndedAtPlaceholder')}
            error={errors?.metadata?.ticket?.distributionEndedAt}
            titleProps={{
              variant: 'subtitle1',
              color: 'text.primary',
            }}
          />
        </Stack>
      )}
    </CellFrame>
  )
}
